import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, testId }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400/90 mb-5">
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        data-testid={testId}
        className="text-2xl sm:text-3xl lg:text-4xl font-serif tracking-tight leading-snug text-[#FBF9F5]"
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.2}>
        <p className="mt-5 text-sm sm:text-base text-stone-400 leading-relaxed">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
